/* eslint-disable no-unused-vars */
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { I18nContext } from "../../../context/I18nProvider";

import spa from "../../../assets/images/flags/flag-spa.svg";
import pt from "../../../assets/images/flags/flag-pt.svg";
import eng from "../../../assets/images/flags/flag-en.svg";

const Flags = ({ setIsMenuOpen, isMenuOpen }) => {
  const { i18n } = useTranslation();
  const { language } = useContext(I18nContext);

  //El idioma lo cambiamos con la instancia de i18n para no correr 2 veces el contexto
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <button
        disabled
        aria-label="Change to english language"
        // onClick={() => changeLanguage("es")}
        // disabled={language === "es"}
      >
        <img
          loading="auto"
          src={spa}
          alt="Icon Language"
          title="Cambiar idioma a español"
        />
      </button>

      <button
        disabled
        aria-label="Change to english language"
        // onClick={() => changeLanguage("en")}
        // disabled={language === "en"}
      >
        <img
          loading="auto"
          src={eng}
          alt="Icon Language"
          title="Change language to english"
        />
      </button>

      <button
        disabled
        aria-label="Change to english language"
        // onClick={() => changeLanguage("pt")}
        // disabled={language === "pt"}
      >
        <img
          loading="auto"
          src={pt}
          alt="Icon Language"
          title="Mudar idioma para português"
        />
      </button>
    </>
  );
};

export default Flags;
